import {
    UserAgent,
    Registerer,
    Inviter,
    SessionState
  } from "sip.js";

  let userAgent;
  let registerer;
  let session;

  export const getSession = () => {
    return session;
  };

  export const registerSip = async (username) => {
    // const uri = UserAgent.makeURI(`sip:${username}@pbx.wdapps.in`);
    const uri = UserAgent.makeURI(`sip:agent_1@pbx.wdapps.in`);

    userAgent = new UserAgent({
      uri,
      transportOptions: {
        server: process.env.REACT_APP_PBX
      },
    //   authorizationUsername: username,
      authorizationUsername: "agent_1",
      authorizationPassword: "1234",
      sessionDescriptionHandlerFactoryOptions: {
        peerConnectionConfiguration: {
          iceServers: [
            { urls: "stun:stun.l.google.com:19302" }
          ]
        }
      }
    });

    await userAgent.start();
    await navigator.mediaDevices.getUserMedia({ audio: true });

    registerer = new Registerer(userAgent);
    await registerer.register();
  };

  export const callNumber = async (number, onStateChange) => {
    const target = UserAgent.makeURI(
      `sip:${number}@pbx.wdapps.in;transport=ws`
    );

    session = new Inviter(userAgent, target);

    session.stateChange.addListener((state) => {
      console.log("SIP State:", state);

      if (state === SessionState.Establishing) {
        onStateChange("DIALING");

        // 🔥 Detect ringing after short delay
        setTimeout(() => {
          if (session.state === SessionState.Establishing) {
            console.log("FORCE RINGING");
            onStateChange("RINGING");
          }
        }, 1000);
      }

      if (state === SessionState.Established) {
        onStateChange("CONNECTED");
        const pc = session.sessionDescriptionHandler.peerConnection;
        const remoteStream = new MediaStream();

        pc.getReceivers().forEach((receiver) => {
            if (receiver.track) {
            remoteStream.addTrack(receiver.track);
            }
        });

        const audioElement = document.getElementById("remoteAudio");
        audioElement.srcObject = remoteStream;
        audioElement.play().catch((e) => console.log("Audio play blocked:", e));
      }

      if (state === SessionState.Terminated) {
        onStateChange("ENDED");
      }
    });

    await session.invite();
  };

  export const hangup = async () => {
    if (!session) return;

    if (session.state === SessionState.Established) {
      await session.bye();
    } else {
      await session.cancel();
    }

    session = null;
  };

  export const toggleMute = () => {
    if (!session) return;

    const pc = session.sessionDescriptionHandler.peerConnection;

    pc.getSenders().forEach((sender) => {
      if (sender.track && sender.track.kind === "audio") {
        sender.track.enabled = !sender.track.enabled;
      }
    });
  };

  export const toggleHold = async () => {
    if (!session) return;

    if (session.state === "Established") {
      await session.invite({
        sessionDescriptionHandlerModifiers: []
      });
    }
  };
